import { ResponsiveImage } from '@/components/elements/ResponsiveImage';
import { IUploadFileEntity } from '@/graphql/__generated__/global/types';
import { getAspectRatio } from '@/lib/getAspectRatio';
import { getImageUrl } from '@/lib/getImageUrl';

type CarouselZoomProps = {
    close: () => void;
    image?: IUploadFileEntity;
};

const CarouselZoomPreview = ({ close, image }: CarouselZoomProps) => {
    const { attributes } = image || {};
    const { alternativeText } = attributes || {};

    return (
        <div
            className={image ? 'top-2 bottom-2 left-2 right-2 flex fixed justify-center items-center overflow-hidden rounded-2xl' : 'hidden'}
            onClick={close}
            style={{
                cursor: 'pointer',
                zIndex: image ? 100 : -1,
            }}
        >
            <div className={'w-full flex relative'}>
                {image ? (
                    <ResponsiveImage
                        alt={alternativeText || ''}
                        aspectRatio={getAspectRatio(attributes)}
                        src={getImageUrl(image)}
                        onClick={close}
                        className="rounded-2xl"
                        sizes={`(max-width: 639px) 70vw, (max-width: 1951px) 50vw, 904px`}
                    />
                ) : null}
            </div>
        </div>
    );
};

export default CarouselZoomPreview;
